<button *ngIf="!isLoggedIn" @fadeIn mat-button (click)="login()">
    <mat-icon style="margin-right: 3px;">account_circle</mat-icon>Login
</button>

<!-- <button *ngIf="!isLoggedIn" @fadeIn mat-button [matMenuTriggerFor]="loginOptionsMenu" #loginOptionsMenuTrigger="matMenuTrigger">
    <mat-icon style="margin-right: 3px;">account_circle</mat-icon>Login
</button>

<mat-menu #loginOptionsMenu="matMenu" [overlapTrigger]="false" class="toolbar-dropdown-menu user-menu">
    <a mat-menu-item (click)="login()" color="accent">
        <mat-icon color="warn">person_pin_circle</mat-icon>
        <span>Trackinator</span>
    </a>
    <mat-divider></mat-divider>
    <a mat-menu-item>
        <button mat-icon-button matTooltip="Facebook" class="mx-1" style="color: #3b5998;">
            <svg class="mat-icon" viewBox="0 0 24 24">
                <path d="M17,2V2H17V6H15C14.31,6 14,6.81 14,7.5V10H14L17,10V14H14V22H10V14H7V10H10V6A4,4 0 0,1 14,2H17Z" />
            </svg>
        </button>
        <span>Facebook</span>
    </a>
    <mat-divider></mat-divider>
    <a mat-menu-item routerLink="help">
        <button mat-icon-button matTooltip="GMail" class="mx-1" style="color: #dd4b39;">
            <svg class="mat-icon" viewBox="0 0 24 24">
                <path d="M23,11H21V9H19V11H17V13H19V15H21V13H23M8,11V13.4H12C11.8,14.4 10.8,16.4 8,16.4C5.6,16.4 3.7,14.4 3.7,12C3.7,9.6 5.6,7.6 8,7.6C9.4,7.6 10.3,8.2 10.8,8.7L12.7,6.9C11.5,5.7 9.9,5 8,5C4.1,5 1,8.1 1,12C1,15.9 4.1,19 8,19C12,19 14.7,16.2 14.7,12.2C14.7,11.7 14.7,11.4 14.6,11H8Z" />
            </svg>
        </button>
        <span>GMail</span>
    </a>
    <mat-divider></mat-divider>
    <a mat-menu-item routerLink="help" class="mx-1" color="primary">
        <mat-icon color="primary">local_post_office</mat-icon>
        <span>Outlook</span>
    </a>
</mat-menu> -->

<button *ngIf="isLoggedIn" @fadeIn mat-icon-button [matMenuTriggerFor]="userMenu" #userMenuTrigger="matMenuTrigger">
    <!-- <img [src]="profilePic" alt="user-image" class="user-info-icon"> -->
    <!-- <app-profile-pic [image]="profilePic" size="small" ></app-profile-pic> -->

    <app-profile-pic size="small"></app-profile-pic>
</button>

<mat-menu #userMenu="matMenu" [overlapTrigger]="false" class="toolbar-dropdown-menu user-menu">
	<mat-card fxLayout="row" fxLayoutAlign="space-around center" class="user-info p-0">
		<!-- <img [src]="profilePic" alt="user-image"> -->
		<!-- <app-profile-pic [image]="profilePic" size="medium"></app-profile-pic> -->

		<app-profile-pic size="medium"></app-profile-pic>

		<div fxLayout="column" fxLayoutAlign="center center">
			<h2>{{menuService.userProfile.name}}</h2>
			<p class="secondary-text-color">Member since {{menuService.userProfile.memberSince | date: 'mediumDate' }}</p>
			<p *ngIf="!menuService.userProfile.isActive" class="secondary-text-color">{{menuService.userProfile.email}}</p>
			<p *ngIf="menuService.userProfile.isActive" class="secondary-text-color" fxShow fxHide.gt-sm>{{menuService.userProfile.email}}</p>
			<p *ngIf="menuService.userProfile.loginProvider" class="secondary-text-color" fxShow fxHide.gt-sm><i>{{menuService.userProfile.loginProvider}}</i></p>
		</div>
	</mat-card>
	<mat-divider></mat-divider>
	<!-- <a mat-menu-item routerLink="/profile" (click)="setActiveModule()">
        <mat-icon>person</mat-icon>
        <span>Profile</span>
    </a> -->
	<a mat-menu-item>
		<mat-icon>person</mat-icon>
		<span>Subscription</span>
	</a>
	<a mat-menu-item routerLink="/help">
		<mat-icon>help</mat-icon>
		<span>Help</span>
	</a>
	<mat-divider></mat-divider>
	<a mat-menu-item (click)="logout()">
		<mat-icon>power_settings_new</mat-icon>
		<span>Log out</span>
	</a>
</mat-menu>